import { useEffect, useState } from "react";
import { useParams, useLocation } from "wouter";

export default function BlogPostPermalinkPage() {
  const [post, setPost] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [location, navigate] = useLocation();
  const params = useParams();
  // params.slug is an array: ["2025", "05", "what-is-solana-volume-bot.html"]
  const slug = Array.isArray(params.slug) ? params.slug.join("/") : params.slug;

  useEffect(() => {
    async function fetchPost() {
      try {
        setLoading(true);
        setError(null);
        // Detect language from URL (e.g., /ar/, /de/, etc.)
        const match = window.location.pathname.match(/^\/(\w{2})(\/|$)/);
        const lang = (match && match[1] !== 'en') ? match[1] : 'en';
        let feedUrl = '/blog-feed';
        if (lang !== 'en') feedUrl = `/blog-feed-${lang}.json`;
        let res = await fetch(feedUrl);
        // Fallback to English if translation file is missing
        if (!res.ok && lang !== 'en') {
          res = await fetch('/blog-feed');
        }
        if (!res.ok) throw new Error('Failed to fetch blog feed');
        const data = await res.json();
        const entries = data.feed?.entry || [];
        // Find the post whose alternate link matches the slug
        const found = entries.find((entry: any) =>
          entry.link.some(
            (l: any) =>
              l.rel === 'alternate' &&
              l.href.includes(slug)
          )
        );
        if (!found) throw new Error('Post not found');
        setPost(found);
        // Set document title
        if (found.title?.$t) document.title = found.title.$t + ' | Solana Volume Bot Blog';
      } catch (err: any) {
        setError(err.message || 'Unknown error');
      } finally {
        setLoading(false);
      }
    }
    fetchPost();
  }, [slug]);

  return (
    <section className="py-20 min-h-screen bg-black/80">
      <div className="container mx-auto px-4 max-w-3xl">
        <button
          className="mb-8 text-white hover:underline font-bold"
          onClick={() => navigate("/blog")}
        >
          ← Back to Blog
        </button>
        {loading && <div className="text-white">Loading post...</div>}
        {error && <div className="text-red-500">{error}</div>}
        {post && (
          <article className="bg-[#18181b] rounded-xl p-8 shadow-lg border border-[#14F195]/40">
            <h1 className="text-3xl font-bold text-white mb-4">{post.title.$t}</h1>
            <div className="flex flex-wrap items-center gap-2 mb-4">
              <span className="text-xs text-white font-semibold">
                {post.author?.[0]?.name?.$t}
              </span>
              <span className="text-gray-200 text-xs">
                {post.published?.$t?.split("T")[0]}
              </span>
            </div>
            <div
              className="prose prose-invert max-w-none text-gray-200"
              dangerouslySetInnerHTML={{ __html: post.content?.$t || "" }}
            />
          </article>
        )}
      </div>
    </section>
  );
} 